export default __webpack_public_path__ + "3666f8bf74f4b45020a24281d7d023f9.png";